import React, { useEffect, useRef, useState } from 'react';
import { Input, Button, message, Row } from 'antd';
import { inspiration_es_batchDelIns, inspiration_es_batchRemoveClassifyTags, removeImgPng } from '../../../api/inspiration'
import './index.less'

export default () => {
    const { TextArea } = Input;
    const [loading1, setLoading1] = useState(false)
    const [value1, setValue1] = useState('')

    const [loading2, setLoading2] = useState(false)
    const [value2, setValue2] = useState('')
    const [loading3, setLoading3] = useState(false)
    const [value3, setValue3] = useState('')
    const getUsername = () => {
        return localStorage.getItem('username');
    };
    const handleClick1 = () => {
        if (!value1) return
        setLoading1(true)
        const insIds = value1.split('\n')
        inspiration_es_batchDelIns(insIds).then(res => {
            if (res.data.error.code == 0) {
                if (res.data?.data?.crawlList?.length) {
                    message.warning(`图片ID ${res.data?.data?.crawlList.join(',')}为用户采集图片,系统无法删除`)
                }
                message.success('操作成功')
            } else {
                message.error(res.data.error.message)
            }
        }).finally(() => { setLoading1(false) })
    }

    const handleClick2 = () => {
        if (!value2) return
        setLoading2(true)
        const insIds = value2.split('\n')
        inspiration_es_batchRemoveClassifyTags(insIds).then(res => {
            if (res.data.error.code == 0) {
                message.success('操作成功')
            } else {
                message.error(res.data.error.message)
            }
        }).finally(() => { setLoading2(false) })
    }
    const handleClick3 = () => {
        if (!value3) return
        setLoading3(true)
        try {
            removeImgPng(value3, getUsername()).then(res => {
                if (res.error.code == 0) {
                    message.success('操作成功')
                    setValue3('')
                } else {
                    message.error(res.error.message)
                }
            }).finally(() => { setLoading3(false) })
        } catch (error) { }
    }

    return <div className='imgDel'>
        <div className='imgDelHeader'>图片管理&gt;图片删除</div>
        <TextArea style={{ width: 500, marginTop: 20 }} rows={4} placeholder='请输入图片id,多个换行' value={value1} onChange={(e) => { setValue1(e.target.value) }} />
        <Button type="primary" loading={loading1} onClick={() => handleClick1()}>
            点击删除图片
        </Button>
        <p></p>
        <TextArea style={{ width: 500 }} rows={4} placeholder='请输入图片id,多个换行' value={value2} onChange={(e) => { setValue2(e.target.value) }} />
        <Button type="primary" loading={loading2} onClick={() => handleClick2()}>
            点击删除新版分类标签
        </Button>
        <p></p>
        <TextArea style={{ width: 500 }} rows={4} placeholder='请输入图片id,多个换行' value={value3} onChange={(e) => { setValue3(e.target.value) }} />
        <Button type="primary" loading={loading3} onClick={() => handleClick3()}>
            点击删除图片PNG标签
        </Button>
    </div>
}